// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_k6-0";
export var fileCarousel = "_k6-2";
export var removeFileButton = "_k6-1";